import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../../services/Auth/auth.service'
import {CompanyService} from '../../services/Company/company.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,private authService:AuthService,private companyService:CompanyService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    /*if (true) {
      return true;
    } else {
      this.router.navigate(['/auth/login'], {
        queryParams: {
          return: state.url
        }
      });
      return false;
    }*/
    const currentuser = this.authService.getCurrentUser();
    const isAuth = this.authService.isAuthenticated();
    
    if (isAuth && currentuser) {
        this.companyService.setList();
        return true;
    }
    else {
      this.router.navigate(['/auth/login'],{
        queryParams: {
          returnurl: state.url
        }
      });
      return false;
    }
  }

}
